import { combineReducers } from 'redux';
import { hospitalsDataReducer } from './hospitalsData/hospitalsData.reducer';
import { filtersReducer } from '../../common/store/filters/filters.reducer';

export const hospitalsReducer = combineReducers({
  hospitalsData: hospitalsDataReducer,
  filters: filtersReducer,
});
